/* eslint-disable prefer-const */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable consistent-return */
import { drawConnectors } from '@mediapipe/drawing_utils';
import { Holistic } from '@mediapipe/holistic';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import {
  FACEMESH_LEFT_EYE,
  FACEMESH_LEFT_EYEBROW,
  FACEMESH_LIPS,
  FACEMESH_RIGHT_EYE,
  FACEMESH_RIGHT_EYEBROW,
  HAND_CONNECTIONS,
  POSE_CONNECTIONS,
} from './mediapipeConnections';

const ROM_JOINTS = [
  { key: 'leftElbow', label: 'Łokieć L', idx: [11, 13, 15] },
  { key: 'rightElbow', label: 'Łokieć P', idx: [12, 14, 16] },
  { key: 'leftKnee', label: 'Kolano L', idx: [23, 25, 27] },
  { key: 'rightKnee', label: 'Kolano P', idx: [24, 26, 28] },
];
const EXERCISES = [
  {
    key: 'lateralFlex',
    label: 'Skłon boczny',
    joint: 'spine',
    instruction: 'Zrób skłon w bok, trzymając proste plecy.',
    flexAngle: 25,
    extAngle: 5,
  },
  {
    key: 'shoulderAbductL',
    label: 'Barki - Odwodzenie L',
    joint: 'leftShoulderExt',
    instruction: 'Unieś lewe ramię bokiem w górę.',
    flexAngle: 120,
    extAngle: 20,
  },
  {
    key: 'shoulderAbductR',
    label: 'Barki - Odwodzenie P',
    joint: 'rightShoulderExt',
    instruction: 'Unieś prawe ramię bokiem w górę.',
    flexAngle: 120,
    extAngle: 20,
  },
  {
    key: 'neckRot',
    label: 'Skręt Szyi',
    joint: 'neckRot',
    instruction: 'Obróć głowę w lewo, potem w prawo.',
    flexAngle: 60,
    extAngle: 10,
  },
];
const EXERCISE_TARGET_REPS = 10;
const ROM_BUFFER_SIZE = 6;
const HISTORY_SIZE = 60;
const ROM_SNAP_DEG = 3;
const ROM_MAX_ANGLE = 200;
const snapAngle = (a, buf) => {
  if (a <= ROM_SNAP_DEG) return 0;
  if (a >= ROM_MAX_ANGLE - ROM_SNAP_DEG) return ROM_MAX_ANGLE;
  if (a >= 177 && a <= 180 && buf && buf.length >= 4) {
    const mean = buf.reduce((s, v) => s + v, 0) / buf.length;
    const variance = buf.reduce((s, v) => s + (v - mean) ** 2, 0) / buf.length;
    if (variance < 3.0) return 180;
  }
  return a;
};
const DraggableWindow = ({
  title,
  children,
  initialX,
  initialY,
  width,
  height,
  style,
  resizable,
  aspectRatio,
  onResize,
}) => {
  const isMobile = window.innerWidth <= 768;
  const initialW = isMobile
    ? Math.min(width || 280, window.innerWidth - 40)
    : width || 280;

  const safeX = Math.max(
    10,
    Math.min(initialX, window.innerWidth - initialW - 10)
  );
  const safeY = Math.max(10, Math.min(initialY, window.innerHeight - 100));

  const [pos, setPos] = useState({ x: safeX, y: safeY });
  const [size, setSize] = useState({ w: initialW, h: height ?? undefined });
  const [minimized, setMinimized] = useState(isMobile);
  const [dragging, setDragging] = useState(false);
  const [resizing, setResizing] = useState(false);
  const [relStart, setRelStart] = useState({ x: 0, y: 0 });
  const [resizeStart, setResizeStart] = useState({ x: 0, y: 0, w: 0, h: 0 });

  useEffect(() => {
    if (width && height && !isMobile) setSize({ w: width, h: height });
  }, [width, height]);

  useEffect(() => {
    const onMove = (e) => {
      if ((dragging || resizing) && e.cancelable) e.preventDefault();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      if (dragging) {
        setPos({
          x: clientX - relStart.x,
          y: clientY - relStart.y,
        });
      }
      if (resizing) {
        const dx = clientX - resizeStart.x;
        const dy = clientY - resizeStart.y;
        const newW = Math.max(150, resizeStart.w + dx);
        let newH;
        if (aspectRatio) {
          const headerH = 35;
          const contentRatio = aspectRatio;
          newH = newW / contentRatio + headerH;
        } else {
          newH = Math.max(100, resizeStart.h + dy);
        }
        setSize({ w: newW, h: newH });
        if (onResize) {
          const headerH = 35;
          onResize({
            width: Math.round(newW),
            height: Math.round(newH - headerH),
          });
        }
      }
    };

    const onEnd = () => {
      setDragging(false);
      setResizing(false);
    };

    if (dragging || resizing) {
      window.addEventListener('mousemove', onMove, { passive: false });
      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('mouseup', onEnd);
      window.addEventListener('touchend', onEnd);
    }

    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('mouseup', onEnd);
      window.removeEventListener('touchend', onEnd);
    };
  }, [dragging, resizing, relStart, resizeStart, aspectRatio, onResize]);

  const onDragStart = (e) => {
    if (e.button !== undefined && e.button !== 0) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    setDragging(true);
    setRelStart({ x: clientX - pos.x, y: clientY - pos.y });
    e.stopPropagation();
    if (e.cancelable) e.preventDefault();
  };

  const onResizeStart = (e) => {
    if (e.button !== undefined && e.button !== 0) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    setResizing(true);
    setResizeStart({ x: clientX, y: clientY, w: size.w, h: size.h });
    e.stopPropagation();
    if (e.cancelable) e.preventDefault();
  };

  return (
    <div
      style={{
        ...style,
        position: 'fixed',
        left: `${pos.x}px`,
        top: `${pos.y}px`,
        width: `${size.w}px`,
        ...(size.h !== undefined && !minimized
          ? { height: `${size.h}px` }
          : {}),
      }}
    >
      <div
        onMouseDown={onDragStart}
        onTouchStart={onDragStart}
        style={{
          cursor: 'grab',
          backgroundColor: 'rgba(0,0,0,0.6)',
          padding: '8px 12px',
          borderBottom: minimized ? 'none' : '1px solid #42d4f4',
          color: '#fff',
          fontSize: '13px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          userSelect: 'none',
        }}
      >
        <span>{title}</span>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setMinimized(!minimized);
          }}
          style={{
            background: 'none',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '14px',
            padding: '0 5px',
          }}
        >
          {minimized ? '▼' : '▲'}
        </button>
      </div>

      {!minimized && (
        <>
          <div
            style={{
              padding: '0',
              height: size.h !== undefined ? 'calc(100% - 35px)' : 'auto',
              overflow: size.h !== undefined ? 'hidden' : 'visible',
            }}
          >
            {children}
          </div>

          {resizable && (
            <div
              onMouseDown={onResizeStart}
              onTouchStart={onResizeStart}
              style={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '30px',
                height: '30px',
                cursor: 'nwse-resize',
                background:
                  'linear-gradient(135deg, transparent 50%, #42d4f4 50%)',
                borderRadius: '0 0 8px 0',
                opacity: 0.7,
              }}
            />
          )}
        </>
      )}
    </div>
  );
};
const Ar = ({ refer }) => {
  const canvasRef = useRef(null);
  const gridCanvasRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [metrics, setMetrics] = useState(null);
  const [gridDims, setGridDims] = useState({ width: 280, height: 210 });
  const [romData, setRomData] = useState({});
  const [romActive, setRomActive] = useState(false);
  const romActiveRef = useRef(false);
  const romDataRef = useRef({});
  const romBufferRef = useRef({});
  const [baselineData, setBaselineData] = useState(null);
  const metricsHistoryRef = useRef({});
  const [exerciseData, setExerciseData] = useState(null);
  const [exerciseSummary, setExerciseSummary] = useState(null);
  const exerciseRef = useRef(null);
  const holisticRef = useRef(null);
  const requestRef = useRef(null);
  const destroyedRef = useRef(false);
  const [canvasStyle, setCanvasStyle] = useState({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 10,
  });

  useEffect(() => {
    const video = refer.current;
    if (!video) return;
    const updateCanvasLayout = () => {
      if (!video.videoWidth || !video.videoHeight) return;
      const rect = video.getBoundingClientRect();
      const containerW = rect.width;
      const containerH = rect.height;
      const videoRatio = video.videoWidth / video.videoHeight;
      const containerRatio = containerW / containerH;
      let renderedW;
      let renderedH;
      let offsetX;
      let offsetY;
      if (videoRatio > containerRatio) {
        renderedW = containerW;
        renderedH = containerW / videoRatio;
        offsetX = 0;
        offsetY = (containerH - renderedH) / 2;
      } else {
        renderedH = containerH;
        renderedW = containerH * videoRatio;
        offsetX = (containerW - renderedW) / 2;
        offsetY = 0;
      }
      setCanvasStyle({
        position: 'absolute',
        top: `${offsetY}px`,
        left: `${offsetX}px`,
        width: `${renderedW}px`,
        height: `${renderedH}px`,
        pointerEvents: 'none',
        zIndex: 10,
      });
    };
    const ro = new ResizeObserver(updateCanvasLayout);
    ro.observe(video);
    video.addEventListener('loadedmetadata', updateCanvasLayout);
    video.addEventListener('resize', updateCanvasLayout);
    updateCanvasLayout();
    return () => {
      ro.disconnect();
      video.removeEventListener('loadedmetadata', updateCanvasLayout);
      video.removeEventListener('resize', updateCanvasLayout);
    };
  }, [refer]);

  const [windowPositions] = useState(() => {
    const isMobile = window.innerWidth <= 768;
    return {
      grid: {
        x: isMobile ? 10 : (window.innerWidth || 1000) - 550,
        y: isMobile ? 80 : (window.innerHeight || 800) - 450,
      },
      metrics: {
        x: isMobile ? 10 : (window.innerWidth || 1000) - 250,
        y: isMobile ? 140 : (window.innerHeight || 800) - 300,
      },
      rom: {
        x: isMobile ? 10 : (window.innerWidth || 1000) - 550,
        y: isMobile ? 20 : 20,
      },
      exercises: {
        x: isMobile ? 10 : 20,
        y: isMobile ? 200 : 20,
      },
    };
  });
  useEffect(() => {
    console.log('[AR Holistic] Initializing...');
    const holistic = new Holistic({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/holistic/${file}`,
    });
    holistic.setOptions({
      modelComplexity: 1,
      smoothLandmarks: true,
      enableSegmentation: false,
      smoothSegmentation: false,
      refineFaceLandmarks: true,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
    });
    holistic.onResults(onResults);
    holisticRef.current = holistic;
    const checkVideo = setInterval(() => {
      if (refer.current && refer.current.readyState >= 2) {
        const v = refer.current;
        if (v.videoWidth && v.videoHeight) {
          const ratio = v.videoWidth / v.videoHeight;
          const newHeight = 280 / ratio;
          setGridDims({ width: 280, height: newHeight });
          console.log(
            `[AR] Video Ratio: ${ratio.toFixed(
              2
            )}, Grid Dims: 280x${newHeight.toFixed(0)}`
          );
        }
        if (v.readyState === 4) {
          clearInterval(checkVideo);
          console.log('[AR Holistic] Video fully ready');
          setIsLoading(false);
          setIsReady(true);
          startLoop();
        }
      }
    }, 500);
    return () => {
      destroyedRef.current = true;
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
      clearInterval(checkVideo);
      if (holisticRef.current) {
        holisticRef.current.close();
        holisticRef.current = null;
      }
    };
  }, []);
  const toggleRom = () => {
    const newVal = !romActiveRef.current;
    if (newVal) {
      const reset = {};
      Object.keys(romDataRef.current).forEach((k) => {
        reset[k] = { current: romDataRef.current[k]?.current };
      });
      romDataRef.current = reset;
      setRomData(reset);
    }
    romActiveRef.current = newVal;
    setRomActive(newVal);
  };
  const resetRom = () => {
    romDataRef.current = {};
    setRomData({});
  };
  const startExercise = (key) => {
    setExerciseSummary(null);
    exerciseRef.current = {
      key,
      reps: 0,
      phase: 'extend',
      startTime: Date.now(),
      maxAngle: 0,
      maxAngleL: 0,
      maxAngleR: 0,
      alerts: [],
      currentAlert: null,
    };
    setExerciseData({
      key,
      reps: 0,
      phase: 'extend',
      angle: null,
      currentAlert: null,
    });
  };
  const stopExercise = () => {
    if (exerciseRef.current && exerciseRef.current.reps > 0) {
      const duration = Math.round(
        (Date.now() - exerciseRef.current.startTime) / 1000
      );
      setExerciseSummary({
        key: exerciseRef.current.key,
        reps: exerciseRef.current.reps,
        duration,
        maxAngle: exerciseRef.current.maxAngle,
        maxAngleL: exerciseRef.current.maxAngleL,
        maxAngleR: exerciseRef.current.maxAngleR,
        alerts: exerciseRef.current.alerts,
        finished: false,
      });
    }
    exerciseRef.current = null;
    setExerciseData(null);
  };
  const resetExercise = () => {
    if (!exerciseRef.current) return;
    const { key } = exerciseRef.current;
    exerciseRef.current = {
      key,
      reps: 0,
      phase: 'extend',
      startTime: Date.now(),
      maxAngle: 0,
      maxAngleL: 0,
      maxAngleR: 0,
      alerts: [],
      currentAlert: null,
    };
    setExerciseData((prev) =>
      prev ? { ...prev, reps: 0, phase: 'extend', currentAlert: null } : null
    );
    setExerciseSummary(null);
  };
  const captureBaseline = () => {
    const metricsSnap = {};
    if (metrics) {
      Object.entries(metrics).forEach(([key, data]) => {
        const num = parseFloat(data.value);
        metricsSnap[key] = Number.isNaN(num) ? null : num;
      });
    }
    const romSnap = {};
    ROM_JOINTS.forEach(({ key }) => {
      romSnap[key] = romDataRef.current[key]?.current ?? null;
    });
    setBaselineData({ metrics: metricsSnap, rom: romSnap });
  };
  const clearBaseline = () => setBaselineData(null);
  const takeSnapshot = () => {
    const video = refer.current;
    const arCanvas = canvasRef.current;
    if (!video || !arCanvas) return;
    const w = arCanvas.width;
    const h = arCanvas.height;
    if (!w || !h) return;
    const offCanvas = document.createElement('canvas');
    offCanvas.width = w;
    offCanvas.height = h;
    const offCtx = offCanvas.getContext('2d');
    offCtx.drawImage(video, 0, 0, w, h);
    offCtx.drawImage(arCanvas, 0, 0, w, h);
    const lineH = 16;
    const pad = 8;
    const lines = [new Date().toLocaleString('pl-PL')];
    if (metrics) {
      Object.entries(metrics).forEach(([, data]) => {
        lines.push(`${data.label.replace(':', '')}  ${data.value}`);
      });
    }
    const romLines = [];
    ROM_JOINTS.forEach(({ key, label }) => {
      const d = romDataRef.current[key];
      if (d?.current !== undefined) {
        let txt = `${label}: ${d.current.toFixed(0)}°`;
        if (d.min !== undefined && d.max !== undefined)
          txt += `  min:${d.min.toFixed(0)}° max:${d.max.toFixed(0)}° Δ${(
            d.max - d.min
          ).toFixed(0)}°`;
        romLines.push(txt);
      }
    });
    if (romLines.length) {
      lines.push('─── ROM ───');
      romLines.forEach((l) => lines.push(l));
    }
    const stripH = lines.length * lineH + pad * 2;
    offCtx.fillStyle = 'rgba(0,0,0,0.78)';
    offCtx.fillRect(0, h - stripH, w, stripH);
    offCtx.font = 'bold 11px monospace';
    lines.forEach((line, i) => {
      offCtx.fillStyle = i === 0 ? '#42d4f4' : '#e0e0e0';
      offCtx.fillText(line, pad, h - stripH + pad + 12 + i * lineH);
    });
    offCanvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `postura-${Date.now()}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 'image/png');
  };
  useEffect(() => {
    if (!metrics) return;
    Object.entries(metrics).forEach(([key, data]) => {
      const num = parseFloat(data.value);
      if (Number.isNaN(num)) return;
      const buf = metricsHistoryRef.current[key] || [];
      buf.push(num);
      if (buf.length > HISTORY_SIZE) buf.shift();
      metricsHistoryRef.current[key] = buf;
    });
  }, [metrics]);
  const startLoop = () => {
    const loop = async () => {
      if (destroyedRef.current || !refer.current || !holisticRef.current)
        return;
      try {
        await holisticRef.current.send({ image: refer.current });
        if (!destroyedRef.current)
          requestRef.current = requestAnimationFrame(loop);
      } catch (err) {
        if (!destroyedRef.current) {
          console.warn('[AR] Holistic send error:', err?.message);
        }
      }
    };
    loop();
  };
  const drawSpineCurve = (
    ctx,
    landmarks,
    side,
    widthFn,
    heightFn,
    sizeScale = 1
  ) => {
    const idx = side === 'left' ? [7, 11, 23, 25, 27] : [8, 12, 24, 26, 28];
    const themeColor = side === 'left' ? '#00FF00' : '#FF00FF';
    ctx.beginPath();
    ctx.lineWidth = 2 * sizeScale;
    let prevNormX = null;
    let prevPixel = null;
    idx.forEach((i, index) => {
      const p = landmarks[i];
      if (!p || p.visibility < 0.5) return;
      const px = p.x * widthFn();
      const py = p.y * heightFn();
      if (prevPixel === null) {
        ctx.moveTo(px, py);
      } else {
        const normDeviation = Math.abs(p.x - prevNormX);
        const segColor =
          normDeviation < 0.03
            ? '#00FF00'
            : normDeviation < 0.08
            ? '#FFFF00'
            : '#FF0000';
        ctx.strokeStyle = segColor;
        ctx.lineTo(px, py);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(px, py);
      }
      prevNormX = p.x;
      prevPixel = { x: px, y: py };
      ctx.fillStyle = themeColor;
      ctx.beginPath();
      ctx.arc(px, py, 2 * sizeScale, 0, 2 * Math.PI);
      ctx.fill();
    });
  };
  const drawLine = (
    ctx,
    p1,
    p2,
    color,
    width,
    widthFn,
    heightFn,
    sizeScale = 1
  ) => {
    if (!p1 || !p2) return;
    ctx.beginPath();
    ctx.moveTo(p1.x * widthFn(), p1.y * heightFn());
    ctx.lineTo(p2.x * widthFn(), p2.y * heightFn());
    ctx.strokeStyle = color;
    ctx.lineWidth = width * sizeScale;
    ctx.stroke();
  };
  const onResults = (results) => {
    if (!canvasRef.current || !refer.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const video = refer.current;
    if (
      canvas.width !== video.videoWidth ||
      canvas.height !== video.videoHeight
    ) {
      canvas.width = video.videoWidth || 640;
      canvas.height = video.videoHeight || 480;
    }
    let gridCtx = null;
    let gridWidth = 0;
    let gridHeight = 0;
    if (gridCanvasRef.current) {
      const gridCanvas = gridCanvasRef.current;
      gridCtx = gridCanvas.getContext('2d');
      gridWidth = gridCanvas.width;
      gridHeight = gridCanvas.height;
      gridCtx.save();
      gridCtx.clearRect(0, 0, gridWidth, gridHeight);
    }
    ctx.save();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const calculateAngle = (p1, p2, p3) => {
      const radians =
        Math.atan2(p3.y - p2.y, p3.x - p2.x) -
        Math.atan2(p1.y - p2.y, p1.x - p2.x);
      let angle = Math.abs((radians * 180.0) / Math.PI);
      if (angle > ROM_MAX_ANGLE) angle = 360 - angle;
      return angle;
    };
    const getPostureColor = (value, goodMax, warningMax) => {
      if (value <= goodMax) return '#00ff00';
      if (value <= warningMax) return '#ffff00';
      return '#ff0000';
    };
    const viewState = {
      isSideView: false,
      isBackView: false,
      visibleSide: 'right',
      exists: false,
    };
    const kp = results.poseLandmarks || [];
    const nose = kp[0];
    const leftShoulder = kp[11];
    const rightShoulder = kp[12];
    const leftHip = kp[23];
    const rightHip = kp[24];
    const isVisible = (p) => p && p.visibility > 0.5;
    const analysis = {
      shoulderAngleColor: '#00ff00',
      neckAngleColor: '#888888',
      spineAngleColor: '#888888',
      hipHeightDiffColor: '#888888',
      shoulderHeightDiffColor: '#888888',
      eyeLevelColor: '#888888',
      headAlignColor: '#888888',
      headForwardColor: '#888888',
      slouchColor: '#888888',
    };
    if (kp.length > 0 && isVisible(leftShoulder) && isVisible(rightShoulder)) {
      viewState.exists = true;
      const midShoulderY = (leftShoulder.y + rightShoulder.y) / 2;
      const midHipY =
        isVisible(leftHip) && isVisible(rightHip)
          ? (leftHip.y + rightHip.y) / 2
          : midShoulderY + 0.4;
      const torsoHeight = Math.abs(midHipY - midShoulderY);
      const shoulderWidth = Math.abs(leftShoulder.x - rightShoulder.x);
      const isSideView =
        shoulderWidth < torsoHeight * 0.35 || shoulderWidth < 0.05;
      viewState.isSideView = isSideView;
      if (!isSideView) {
        const isBackView = !isVisible(nose);
        viewState.isBackView = isBackView;
        const shoulderAngleRad = Math.atan2(
          rightShoulder.y - leftShoulder.y,
          rightShoulder.x - leftShoulder.x
        );
        const shoulderDeg = (shoulderAngleRad * 180) / Math.PI;
        let shoulderDeviation = Math.abs(shoulderDeg);
        if (shoulderDeviation > 90)
          shoulderDeviation = Math.abs(180 - shoulderDeviation);
        analysis.shoulderAngleColor = getPostureColor(shoulderDeviation, 2, 5);
        const shoulderDiff =
          Math.abs(leftShoulder.y - rightShoulder.y) * canvas.height;
        analysis.shoulderHeightDiffColor = getPostureColor(
          shoulderDiff,
          10,
          25
        );
        let neckDeviation = 0;
        const shoulderMidX = (leftShoulder.x + rightShoulder.x) / 2;
        const shoulderMidY = (leftShoulder.y + rightShoulder.y) / 2;
        if (!isBackView && isVisible(nose)) {
          const neckAngle = calculateAngle(
            { x: shoulderMidX, y: shoulderMidY },
            nose,
            { x: shoulderMidX, y: 0 }
          );
          neckDeviation = Math.abs(180 - neckAngle);
          analysis.neckAngleColor = getPostureColor(neckDeviation, 5, 12);
        }
        let spineDeviation = 0;
        if (isVisible(leftHip) && isVisible(rightHip)) {
          const hipMidX = (leftHip.x + rightHip.x) / 2;
          const hipMidY = (leftHip.y + rightHip.y) / 2;
          const spineAngle = calculateAngle(
            { x: hipMidX, y: hipMidY },
            { x: shoulderMidX, y: shoulderMidY },
            { x: hipMidX, y: 0 }
          );
          spineDeviation = Math.abs(180 - spineAngle);
          analysis.spineAngleColor = getPostureColor(spineDeviation, 2, 6);
          const hipDiff = Math.abs(leftHip.y - rightHip.y) * canvas.height;
          analysis.hipHeightDiffColor = getPostureColor(hipDiff, 10, 25);
        }
        const le = kp[2];
        const re = kp[5];
        if (!isBackView && isVisible(le) && isVisible(re)) {
          let eyeDeg = Math.abs(
            (Math.atan2(re.y - le.y, re.x - le.x) * 180) / Math.PI
          );
          if (eyeDeg > 90) eyeDeg = Math.abs(180 - eyeDeg);
          analysis.eyeLevelColor = getPostureColor(eyeDeg, 2, 5);
          if (isVisible(nose)) {
            const smX = (leftShoulder.x + rightShoulder.x) / 2;
            const smY = (leftShoulder.y + rightShoulder.y) / 2;
            const emX = (le.x + re.x) / 2;
            const emY = (le.y + re.y) / 2;
            const neckAng = Math.atan2(nose.y - smY, nose.x - smX);
            const headAng = Math.atan2(emY - nose.y, emX - nose.x);
            let hDiff = Math.abs(((neckAng - headAng) * 180) / Math.PI);
            if (hDiff > 180) hDiff = 360 - hDiff;
            analysis.headAlignColor = getPostureColor(hDiff, 5, 12);
          }
        }
        setMetrics({
          view: {
            label: 'Widok:',
            value: isBackView ? 'Tył' : 'Przód',
            color: isBackView ? '#eb4bf5' : '#42d4f4',
          },
          shoulderAngle: {
            label: 'Kąt ramion:',
            value: `${shoulderDeviation.toFixed(1)}°`,
            color: analysis.shoulderAngleColor,
          },
          shoulderHeight: {
            label: 'Różnica ramion:',
            value: `${shoulderDiff.toFixed(0)}px`,
            color: analysis.shoulderHeightDiffColor,
          },
          neckAngle: {
            label: 'Kąt szyi:',
            value:
              !isBackView && isVisible(nose)
                ? `${neckDeviation.toFixed(1)}°`
                : 'N/A',
            color: analysis.neckAngleColor,
          },
          spineAngle: {
            label: 'Pion kręgosłupa:',
            value: isVisible(leftHip) ? `${spineDeviation.toFixed(1)}°` : 'N/A',
            color: analysis.spineAngleColor,
          },
          hipHeight: {
            label: 'Różnica bioder:',
            value: isVisible(leftHip)
              ? `${(Math.abs(leftHip.y - rightHip.y) * canvas.height).toFixed(
                  0
                )}px`
              : 'N/A',
            color: analysis.hipHeightDiffColor,
          },
          eyeLevel: {
            label: 'Poziom oczu:',
            value:
              !isBackView && isVisible(le) && isVisible(re)
                ? (() => {
                    let d = Math.abs(
                      (Math.atan2(re.y - le.y, re.x - le.x) * 180) / Math.PI
                    );
                    if (d > 90) d = Math.abs(180 - d);
                    return `${d.toFixed(1)}°`;
                  })()
                : 'N/A',
            color: analysis.eyeLevelColor,
          },
          headAlign: {
            label: 'Głowa-Szyja:',
            value:
              !isBackView && isVisible(nose) && isVisible(le) && isVisible(re)
                ? (() => {
                    const smX = (leftShoulder.x + rightShoulder.x) / 2;
                    const smY = (leftShoulder.y + rightShoulder.y) / 2;
                    const emX = (le.x + re.x) / 2;
                    const emY = (le.y + re.y) / 2;
                    const neckAng = Math.atan2(nose.y - smY, nose.x - smX);
                    const headAng = Math.atan2(emY - nose.y, emX - nose.x);
                    let d = Math.abs(((neckAng - headAng) * 180) / Math.PI);
                    if (d > 180) d = 360 - d;
                    return `${d.toFixed(1)}°`;
                  })()
                : 'N/A',
            color: analysis.headAlignColor,
          },
        });
      } else {
        viewState.visibleSide =
          leftShoulder.x < rightShoulder.x ? 'left' : 'right';
        const ear = viewState.visibleSide === 'left' ? kp[7] : kp[8];
        const shoulder = viewState.visibleSide === 'left' ? kp[11] : kp[12];
        const hip = viewState.visibleSide === 'left' ? kp[23] : kp[24];
        let headForward = 0;
        let headForwardColor = '#888888';
        if (isVisible(ear) && isVisible(shoulder)) {
          headForward = Math.abs(ear.x - shoulder.x) * canvas.width;
          headForwardColor = getPostureColor(headForward, 30, 60);
        }
        let slouchAngle = 'N/A';
        let slouchColor = '#888888';
        if (isVisible(ear) && isVisible(shoulder) && isVisible(hip)) {
          const ang = calculateAngle(ear, shoulder, hip);
          const dev = Math.abs(180 - ang);
          slouchAngle = `${ang.toFixed(1)}°`;
          slouchColor = getPostureColor(dev, 15, 30);
        }
        analysis.headForwardColor = headForwardColor;
        analysis.slouchColor = slouchColor;
        setMetrics({
          view: {
            label: 'Widok:',
            value: viewState.visibleSide === 'left' ? 'Bok (L)' : 'Bok (P)',
            color: '#ff9d00',
          },
          headForward: {
            label: 'Głowa przód:',
            value: `${headForward.toFixed(0)}px`,
            color: headForwardColor,
          },
          slouch: {
            label: 'Kąt tułowia:',
            value: slouchAngle,
            color: slouchColor,
          },
        });
      }
    }
    const newRomData = {};
    ROM_JOINTS.forEach(({ key, idx }) => {
      const [i1, i2, i3] = idx;
      const p1 = kp[i1];
      const p2 = kp[i2];
      const p3 = kp[i3];
      if (!isVisible(p1) || !isVisible(p2) || !isVisible(p3)) {
        if (romDataRef.current[key]) newRomData[key] = romDataRef.current[key];
        return;
      }
      const raw = calculateAngle(p1, p2, p3);
      const buf = romBufferRef.current[key] || [];
      buf.push(raw);
      if (buf.length > ROM_BUFFER_SIZE) buf.shift();
      romBufferRef.current[key] = buf;
      const smoothed = buf.reduce((a, b) => a + b, 0) / buf.length;
      const angle = snapAngle(smoothed, buf);
      const prev = romDataRef.current[key];
      if (romActiveRef.current) {
        newRomData[key] = {
          current: angle,
          min: prev?.min !== undefined ? Math.min(prev.min, angle) : angle,
          max: prev?.max !== undefined ? Math.max(prev.max, angle) : angle,
        };
      } else {
        newRomData[key] = { current: angle, min: prev?.min, max: prev?.max };
      }
    });
    romDataRef.current = newRomData;
    setRomData(newRomData);
    const exState = exerciseRef.current;
    if (exState) {
      const ex = EXERCISES.find((e) => e.key === exState.key);
      if (ex) {
        let ang;
        let direction = null;
        let formAlert = null;
        const now = Date.now();
        if (ex.key === 'lateralFlex') {
          if (
            isVisible(leftShoulder) &&
            isVisible(rightShoulder) &&
            isVisible(leftHip) &&
            isVisible(rightHip)
          ) {
            const shoulderMidX = (leftShoulder.x + rightShoulder.x) / 2;
            const shoulderMidY = (leftShoulder.y + rightShoulder.y) / 2;
            const hipMidX = (leftHip.x + rightHip.x) / 2;
            const hipMidY = (leftHip.y + rightHip.y) / 2;
            ang = calculateAngle(
              { x: shoulderMidX, y: shoulderMidY },
              { x: hipMidX, y: hipMidY },
              { x: hipMidX, y: 0 }
            );
            if (ang > 180) {
              ang = 360 - ang;
            }
            if (viewState.isSideView) {
              formAlert = 'Obrócony przodem do kamery!';
            } else {
              const shoulderZDiff = Math.abs(leftShoulder.z - rightShoulder.z);
              if (shoulderZDiff > 0.15) {
                formAlert = 'Skręcasz tułów! Trzymaj w jednej płaszczyźnie.';
              }
            }
          }
        } else if (
          ex.key === 'shoulderAbductL' ||
          ex.key === 'shoulderAbductR'
        ) {
          const isLeft = ex.key === 'shoulderAbductL';
          const shoulder = isLeft ? leftShoulder : rightShoulder;
          const hip = isLeft ? leftHip : rightHip;
          const elbow = isLeft ? kp[13] : kp[14];
          const wrist = isLeft ? kp[15] : kp[16];
          if (isVisible(shoulder) && isVisible(hip) && isVisible(elbow)) {
            ang = calculateAngle(hip, shoulder, elbow);
            if (isVisible(wrist)) {
              const elbowAngle = calculateAngle(shoulder, elbow, wrist);
              if (elbowAngle < 150) {
                formAlert = 'Wyprostuj łokieć!';
              }
            }
            if (isVisible(leftShoulder) && isVisible(rightShoulder)) {
              const otherShoulder = isLeft ? rightShoulder : leftShoulder;
              if (shoulder.y < otherShoulder.y - 0.05) {
                formAlert = 'Nie unoś barku do ucha!';
              }
            }
          }
        } else if (ex.key === 'neckRot') {
          if (
            isVisible(nose) &&
            isVisible(leftShoulder) &&
            isVisible(rightShoulder)
          ) {
            const minShoulderX = Math.min(leftShoulder.x, rightShoulder.x);
            const maxShoulderX = Math.max(leftShoulder.x, rightShoulder.x);
            const shoulderWidth = maxShoulderX - minShoulderX;
            if (shoulderWidth > 0.05) {
              const noseRelX = (nose.x - minShoulderX) / shoulderWidth;
              ang = Math.abs(noseRelX - 0.5) * 180;
              direction = noseRelX < 0.5 ? 'L' : 'R';
            } else {
              ang = 0;
            }
            const shoulderDiff = Math.abs(leftShoulder.y - rightShoulder.y);
            if (shoulderDiff > 0.08) {
              formAlert = 'Nie unoś barków przy skręcie!';
            }
          }
        }
        if (ang !== undefined) {
          let { phase, reps, maxAngle, maxAngleL, maxAngleR, alerts } = exState;
          if (ang > maxAngle) {
            maxAngle = ang;
          }
          if (direction === 'L' && ang > maxAngleL) {
            maxAngleL = ang;
          } else if (direction === 'R' && ang > maxAngleR) {
            maxAngleR = ang;
          }
          if (
            formAlert &&
            (!exState.currentAlert ||
              now - exState.currentAlert.timestamp > 3000)
          ) {
            alerts.push({
              time: new Date().toLocaleTimeString(),
              message: formAlert,
            });
          }
          if (reps < EXERCISE_TARGET_REPS) {
            if (phase === 'extend' && ang >= ex.flexAngle) {
              phase = 'flex';
            } else if (phase === 'flex' && ang <= ex.extAngle) {
              phase = 'extend';
              reps += 1;
              if (reps >= EXERCISE_TARGET_REPS) {
                setTimeout(() => stopExercise(), 100);
              }
            }
            if (
              phase !== exState.phase ||
              reps !== exState.reps ||
              maxAngle !== exState.maxAngle ||
              formAlert !== exState.currentAlert?.message
            ) {
              const newAlert = formAlert
                ? { message: formAlert, timestamp: now }
                : exState.currentAlert;
              exerciseRef.current = {
                ...exState,
                phase,
                reps,
                maxAngle,
                maxAngleL,
                maxAngleR,
                alerts,
                currentAlert: newAlert,
              };
            }
          }
          setExerciseData({
            key: exState.key,
            reps,
            phase,
            angle: ang,
            currentAlert:
              formAlert ||
              (exState.currentAlert &&
              now - exState.currentAlert.timestamp < 3000
                ? exState.currentAlert.message
                : null),
          });
        }
      }
    }
    const drawSkeleton = (targetCtx, wFn, hFn) => {
      if (!results.poseLandmarks) return;
      const { isSideView, isBackView, visibleSide } = viewState;
      if (!isSideView) {
        const BODY_CONNECTIONS = POSE_CONNECTIONS.filter(
          ([i, j]) => !(i >= 17 && i <= 22) && !(j >= 17 && j <= 22)
        );
        drawConnectors(targetCtx, results.poseLandmarks, BODY_CONNECTIONS, {
          color: '#00ff0040',
          lineWidth: 2,
        });
        if (isVisible(leftShoulder) && isVisible(rightShoulder)) {
          drawLine(
            targetCtx,
            leftShoulder,
            rightShoulder,
            analysis.shoulderAngleColor,
            2,
            wFn,
            hFn
          );
          if (!isBackView && isVisible(nose)) {
            drawLine(
              targetCtx,
              leftShoulder,
              nose,
              analysis.neckAngleColor,
              2,
              wFn,
              hFn
            );
            drawLine(
              targetCtx,
              rightShoulder,
              nose,
              analysis.neckAngleColor,
              2,
              wFn,
              hFn
            );
          }
          if (isVisible(leftHip) && isVisible(rightHip)) {
            drawLine(
              targetCtx,
              leftShoulder,
              leftHip,
              analysis.spineAngleColor,
              2,
              wFn,
              hFn
            );
            drawLine(
              targetCtx,
              rightShoulder,
              rightHip,
              analysis.spineAngleColor,
              2,
              wFn,
              hFn
            );
            drawLine(
              targetCtx,
              leftHip,
              rightHip,
              analysis.hipHeightDiffColor,
              2,
              wFn,
              hFn
            );
          }
          const le = results.poseLandmarks[2];
          const re = results.poseLandmarks[5];
          const n = results.poseLandmarks[0];
          if (isVisible(le) && isVisible(re) && !isBackView) {
            drawLine(targetCtx, le, re, analysis.eyeLevelColor, 2, wFn, hFn);
            if (isVisible(n)) {
              const smX = (leftShoulder.x + rightShoulder.x) / 2;
              const smY = (leftShoulder.y + rightShoulder.y) / 2;
              const emX = (le.x + re.x) / 2;
              const emY = (le.y + re.y) / 2;
              const sm = { x: smX, y: smY };
              const em = { x: emX, y: emY };
              drawLine(targetCtx, sm, n, analysis.headAlignColor, 2, wFn, hFn);
              drawLine(targetCtx, n, em, analysis.headAlignColor, 2, wFn, hFn);
              targetCtx.fillStyle = analysis.headAlignColor;
              targetCtx.beginPath();
              targetCtx.arc(n.x * wFn(), n.y * hFn(), 2, 0, 2 * Math.PI);
              targetCtx.fill();
            }
          }
        }
      } else {
        drawSpineCurve(targetCtx, kp, 'left', wFn, hFn);
        drawSpineCurve(targetCtx, kp, 'right', wFn, hFn);
      }
      if (results.faceLandmarks) {
        drawConnectors(targetCtx, results.faceLandmarks, FACEMESH_RIGHT_EYE, {
          color: '#FF3030',
          lineWidth: 2,
        });
        drawConnectors(
          targetCtx,
          results.faceLandmarks,
          FACEMESH_RIGHT_EYEBROW,
          { color: '#FF3030', lineWidth: 2 }
        );
        drawConnectors(targetCtx, results.faceLandmarks, FACEMESH_LEFT_EYE, {
          color: '#30FF30',
          lineWidth: 2,
        });
        drawConnectors(
          targetCtx,
          results.faceLandmarks,
          FACEMESH_LEFT_EYEBROW,
          { color: '#30FF30', lineWidth: 2 }
        );
        drawConnectors(targetCtx, results.faceLandmarks, FACEMESH_LIPS, {
          color: '#FFFFFF40',
          lineWidth: 2,
        });
      }
      const connectWrists = (poseIdx, handLandmarks) => {
        if (!handLandmarks || !results.poseLandmarks[poseIdx]) return;
        drawLine(
          targetCtx,
          results.poseLandmarks[poseIdx],
          handLandmarks[0],
          '#00ff0060',
          2,
          wFn,
          hFn
        );
      };
      connectWrists(15, results.leftHandLandmarks);
      connectWrists(16, results.rightHandLandmarks);
      drawConnectors(targetCtx, results.leftHandLandmarks, HAND_CONNECTIONS, {
        color: '#00FF0080',
        lineWidth: 2,
      });
      drawConnectors(targetCtx, results.rightHandLandmarks, HAND_CONNECTIONS, {
        color: '#FF00FF80',
        lineWidth: 2,
      });
    };
    drawSkeleton(
      ctx,
      () => canvas.width,
      () => canvas.height
    );
    if (gridCtx) {
      drawSkeleton(
        gridCtx,
        () => gridWidth,
        () => gridHeight
      );
    }
    const ARC_R = 25;
    const drawJointAngles = (targetCtx, wFn, hFn) => {
      if (!results.poseLandmarks) return;
      ROM_JOINTS.forEach(({ key, idx }) => {
        const d = romDataRef.current[key];
        if (!d || d.current === undefined) return;
        const p1 = kp[idx[0]];
        const p2 = kp[idx[1]];
        const p3 = kp[idx[2]];
        if (!isVisible(p1) || !isVisible(p2) || !isVisible(p3)) return;
        const cx = p2.x * wFn();
        const cy = p2.y * hFn();
        const x1 = p1.x * wFn();
        const y1 = p1.y * hFn();
        const x3 = p3.x * wFn();
        const y3 = p3.y * hFn();
        const color = romActiveRef.current ? '#00ff88' : '#42d4f4';
        targetCtx.fillStyle = color;
        targetCtx.beginPath();
        targetCtx.arc(cx, cy, 4, 0, 2 * Math.PI);
        targetCtx.fill();
        const ang1 = Math.atan2(y1 - cy, x1 - cx);
        const ang3 = Math.atan2(y3 - cy, x3 - cx);
        const cross = (x1 - cx) * (y3 - cy) - (y1 - cy) * (x3 - cx);
        const anticlockwise = cross < 0;
        targetCtx.beginPath();
        targetCtx.strokeStyle = color;
        targetCtx.lineWidth = 2;
        targetCtx.globalAlpha = 0.8;
        targetCtx.arc(cx, cy, ARC_R, ang1, ang3, anticlockwise);
        targetCtx.stroke();
        targetCtx.globalAlpha = 1;
        const len1 = Math.hypot(x1 - cx, y1 - cy);
        const len3 = Math.hypot(x3 - cx, y3 - cy);
        const bx = (x1 - cx) / len1 + (x3 - cx) / len3;
        const by = (y1 - cy) / len1 + (y3 - cy) / len3;
        const bLen = Math.hypot(bx, by);
        const labelDist = ARC_R + 14;
        let lx;
        let ly;
        if (bLen < 0.15) {
          lx = cx;
          ly = cy - labelDist;
        } else {
          lx = cx + (bx / bLen) * labelDist;
          ly = cy + (by / bLen) * labelDist;
        }
        const text = `${Math.round(d.current)}°`;
        targetCtx.font = `bold 11px monospace`;
        targetCtx.textAlign = 'center';
        targetCtx.strokeStyle = 'rgba(0,0,0,0.85)';
        targetCtx.lineWidth = 3;
        targetCtx.strokeText(text, lx, ly);
        targetCtx.fillStyle = '#fff';
        targetCtx.fillText(text, lx, ly);
        targetCtx.textAlign = 'left';
      });
    };
    drawJointAngles(
      ctx,
      () => canvas.width,
      () => canvas.height
    );
    if (gridCtx) {
      drawJointAngles(
        gridCtx,
        () => gridWidth,
        () => gridHeight
      );
    }
    const RED = '#ff0000';
    const drawAlerts = (targetCtx, wFn, hFn) => {
      if (!results.poseLandmarks || !viewState.exists) return;
      const pulse = 0.35 + 0.35 * Math.abs(Math.sin(Date.now() / 400));
      const ring = (lmkIdx, radius = 18) => {
        const p = kp[lmkIdx];
        if (!isVisible(p)) return;
        const x = p.x * wFn();
        const y = p.y * hFn();
        targetCtx.beginPath();
        targetCtx.arc(x, y, radius, 0, 2 * Math.PI);
        targetCtx.fillStyle = `rgba(255,40,40,${(pulse * 0.25).toFixed(2)})`;
        targetCtx.fill();
        targetCtx.beginPath();
        targetCtx.arc(x, y, radius, 0, 2 * Math.PI);
        targetCtx.strokeStyle = `rgba(255,40,40,${pulse.toFixed(2)})`;
        targetCtx.lineWidth = 3;
        targetCtx.stroke();
      };
      if (!viewState.isSideView) {
        if (
          analysis.spineAngleColor === RED ||
          analysis.shoulderHeightDiffColor === RED
        ) {
          if (isVisible(kp[11]) && isVisible(kp[12])) {
            ring(11, 18);
            ring(12, 18);
          }
        }
        if (analysis.spineAngleColor === RED) {
          if (isVisible(kp[23]) && isVisible(kp[24])) {
            ring(23, 18);
            ring(24, 18);
          }
        }
        if (
          analysis.neckAngleColor === RED ||
          analysis.headAlignColor === RED
        ) {
          if (isVisible(kp[0])) ring(0, 22);
        }
        if (analysis.hipHeightDiffColor === RED) {
          if (isVisible(kp[23]) && isVisible(kp[24])) {
            ring(23, 20);
            ring(24, 20);
          }
        }
      } else {
        const earIdx = viewState.visibleSide === 'left' ? 7 : 8;
        const shoulderIdx = viewState.visibleSide === 'left' ? 11 : 12;
        if (analysis.headForwardColor === RED && isVisible(kp[earIdx]))
          ring(earIdx, 22);
        if (analysis.slouchColor === RED && isVisible(kp[shoulderIdx]))
          ring(shoulderIdx, 22);
      }
    };
    drawAlerts(
      ctx,
      () => canvas.width,
      () => canvas.height
    );
    if (gridCtx)
      drawAlerts(
        gridCtx,
        () => gridWidth,
        () => gridHeight
      );
    ctx.restore();
    if (gridCtx) gridCtx.restore();
  };
  return (
    <>
      <canvas ref={canvasRef} style={canvasStyle} />
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 999999,
            backgroundColor: 'rgba(0,0,0,0.8)',
            padding: '20px',
            borderRadius: '10px',
            color: '#fff',
          }}
        >
          Wczytywanie modułu AR...
        </div>
      )}
      {isReady &&
        createPortal(
          <DraggableWindow
            title="Szkielet 1:1"
            initialX={windowPositions.grid.x}
            initialY={windowPositions.grid.y}
            width={gridDims.width}
            height={gridDims.height + 35}
            resizable
            aspectRatio={gridDims.width / gridDims.height}
            onResize={(newDims) => {
              setGridDims({ width: newDims.width, height: newDims.height });
            }}
            style={{
              backgroundColor: '#111',
              border: '2px solid #42d4f4',
              borderRadius: '8px',
              zIndex: 10000,
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
              backgroundImage: `
                    linear-gradient(to right, #333 1px, transparent 1px),
                    linear-gradient(to bottom, #333 1px, transparent 1px)
                `,
              backgroundSize: '40px 40px',
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <canvas
                ref={gridCanvasRef}
                width={gridDims.width}
                height={gridDims.height}
                style={{ display: 'block', width: '100%', height: '100%' }}
              />
            </div>
          </DraggableWindow>,
          document.body
        )}
      {isReady &&
        createPortal(
          <DraggableWindow
            title="Ćwiczenia"
            initialX={windowPositions.exercises.x}
            initialY={windowPositions.exercises.y}
            width={200}
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              border: '2px solid #a259ff',
              borderRadius: '8px',
              color: '#fff',
              zIndex: 10003,
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
            }}
          >
            <div style={{ padding: '10px' }}>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '4px',
                  marginBottom: '10px',
                }}
              >
                {EXERCISES.map((ex) => (
                  <button
                    key={ex.key}
                    type="button"
                    onClick={() => startExercise(ex.key)}
                    style={{
                      padding: '4px 8px',
                      background:
                        exerciseData?.key === ex.key ? '#2a1a4a' : '#1a1a1a',
                      border: `1px solid ${
                        exerciseData?.key === ex.key ? '#a259ff' : '#444'
                      }`,
                      borderRadius: '3px',
                      color: exerciseData?.key === ex.key ? '#c084fc' : '#888',
                      fontSize: '10px',
                      cursor: 'pointer',
                      fontWeight:
                        exerciseData?.key === ex.key ? 'bold' : 'normal',
                    }}
                  >
                    {ex.label}
                  </button>
                ))}
              </div>
              {exerciseSummary ? (
                <div style={{ textAlign: 'center' }}>
                  <div
                    style={{
                      color: '#00ff88',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      marginBottom: '8px',
                    }}
                  >
                    Ćwiczenie Ukończone!
                  </div>
                  <div style={{ fontSize: '12px', marginBottom: '4px' }}>
                    Czas:{' '}
                    <span style={{ color: '#fff' }}>
                      {exerciseSummary.duration}s
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', marginBottom: '8px' }}>
                    Max zakres:{' '}
                    {exerciseSummary.key === 'neckRot' ? (
                      <span style={{ color: '#fff' }}>
                        L: {Math.round(exerciseSummary.maxAngleL)}° / P:{' '}
                        {Math.round(exerciseSummary.maxAngleR)}°
                      </span>
                    ) : (
                      <span style={{ color: '#fff' }}>
                        {Math.round(exerciseSummary.maxAngle)}°
                      </span>
                    )}
                  </div>
                  {exerciseSummary.alerts.length > 0 && (
                    <div
                      style={{
                        background: '#330000',
                        padding: '6px',
                        borderRadius: '4px',
                        textAlign: 'left',
                        maxHeight: '80px',
                        overflowY: 'auto',
                      }}
                    >
                      <div
                        style={{
                          color: '#ff4444',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          marginBottom: '4px',
                        }}
                      >
                        Wykryte błędy:
                      </div>
                      {exerciseSummary.alerts.map((a) => (
                        <div
                          key={a.time + a.message}
                          style={{
                            fontSize: '10px',
                            color: '#ffaaaa',
                            marginBottom: '2px',
                          }}
                        >
                          [{a.time}] {a.message}
                        </div>
                      ))}
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={() => setExerciseSummary(null)}
                    style={{
                      marginTop: '10px',
                      padding: '4px 8px',
                      background: '#222',
                      border: '1px solid #444',
                      borderRadius: '3px',
                      color: '#888',
                      fontSize: '10px',
                      cursor: 'pointer',
                      width: '100%',
                    }}
                  >
                    Zamknij
                  </button>
                </div>
              ) : exerciseData ? (
                <>
                  <div style={{ textAlign: 'center', margin: '4px 0 8px' }}>
                    <div
                      style={{
                        fontSize: '44px',
                        fontWeight: 'bold',
                        lineHeight: 1,
                        color:
                          exerciseData.reps >= EXERCISE_TARGET_REPS
                            ? '#00ff88'
                            : exerciseData.phase === 'flex'
                            ? '#00ff88'
                            : '#42d4f4',
                      }}
                    >
                      {exerciseData.angle !== null
                        ? `${Math.round(exerciseData.angle)}°`
                        : '—'}
                    </div>
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '11px',
                        marginBottom: '4px',
                      }}
                    >
                      <span style={{ color: '#aaa' }}>Powtórzenia</span>
                      <span
                        style={{
                          color:
                            exerciseData.reps >= EXERCISE_TARGET_REPS
                              ? '#00ff88'
                              : '#fff',
                          fontWeight: 'bold',
                        }}
                      >
                        {exerciseData.reps} / {EXERCISE_TARGET_REPS}
                      </span>
                    </div>
                    <div
                      style={{
                        background: '#333',
                        height: '6px',
                        borderRadius: '3px',
                      }}
                    >
                      <div
                        style={{
                          width: `${Math.min(
                            100,
                            (exerciseData.reps / EXERCISE_TARGET_REPS) * 100
                          )}%`,
                          height: '100%',
                          background:
                            exerciseData.reps >= EXERCISE_TARGET_REPS
                              ? '#00ff88'
                              : '#a259ff',
                          borderRadius: '3px',
                          transition: 'width 0.3s',
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: 'center',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      color:
                        exerciseData.reps >= EXERCISE_TARGET_REPS
                          ? '#00ff88'
                          : '#aaa',
                      marginBottom: '6px',
                    }}
                  >
                    {exerciseData.reps >= EXERCISE_TARGET_REPS
                      ? '✓ Zakończono! (Przetwarzam...)'
                      : exerciseData.phase === 'flex'
                      ? 'Powrót'
                      : 'Naciągnij'}
                  </div>
                  <div
                    style={{
                      fontSize: '10px',
                      color: '#555',
                      textAlign: 'center',
                      marginBottom: '8px',
                    }}
                  >
                    {
                      EXERCISES.find((e) => e.key === exerciseData.key)
                        ?.instruction
                    }
                  </div>
                  {exerciseData.currentAlert && (
                    <div
                      style={{
                        background: 'rgba(255, 0, 0, 0.2)',
                        border: '1px solid red',
                        color: '#ffaaaa',
                        fontSize: '11px',
                        padding: '4px',
                        textAlign: 'center',
                        borderRadius: '4px',
                        marginBottom: '8px',
                        animation: 'blink 1s linear infinite',
                      }}
                    >
                      ⚠️ {exerciseData.currentAlert}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button
                      type="button"
                      onClick={stopExercise}
                      style={{
                        flex: 1,
                        padding: '4px 0',
                        background: '#330000',
                        border: '1px solid #660000',
                        borderRadius: '3px',
                        color: '#ff6644',
                        fontSize: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      Zakończ
                    </button>
                    <button
                      type="button"
                      onClick={resetExercise}
                      style={{
                        padding: '4px 8px',
                        background: '#222',
                        border: '1px solid #444',
                        borderRadius: '3px',
                        color: '#888',
                        fontSize: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    color: '#555',
                    fontSize: '11px',
                    textAlign: 'center',
                    padding: '10px 0',
                  }}
                >
                  Wybierz ćwiczenie powyżej
                </div>
              )}
            </div>
          </DraggableWindow>,
          document.body
        )}
      {isReady &&
        createPortal(
          <DraggableWindow
            title="ROM — Zakres Ruchu"
            initialX={windowPositions.rom.x}
            initialY={windowPositions.rom.y}
            width={240}
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              border: `2px solid ${romActive ? '#00ff88' : '#42d4f4'}`,
              borderRadius: '8px',
              color: '#fff',
              zIndex: 10002,
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
            }}
          >
            <div style={{ padding: '10px' }}>
              <div
                style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}
              >
                <button
                  type="button"
                  onClick={toggleRom}
                  style={{
                    flex: 1,
                    padding: '5px 0',
                    background: romActive ? '#cc3333' : '#007744',
                    border: 'none',
                    borderRadius: '4px',
                    color: '#fff',
                    fontSize: '11px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  {romActive ? '⏹ Stop' : '▶ Nagraj ROM'}
                </button>
                <button
                  type="button"
                  onClick={resetRom}
                  style={{
                    padding: '5px 8px',
                    background: '#333',
                    border: '1px solid #555',
                    borderRadius: '4px',
                    color: '#aaa',
                    fontSize: '11px',
                    cursor: 'pointer',
                  }}
                >
                  Reset
                </button>
              </div>
              {ROM_JOINTS.map(({ key, label }) => {
                const d = romData[key];
                if (!d || d.current === undefined)
                  return (
                    <div
                      key={key}
                      style={{
                        marginBottom: '10px',
                        fontSize: '11px',
                        color: '#444',
                      }}
                    >
                      <span style={{ color: '#42d4f4' }}>{label}</span> —
                      niewidoczny
                    </div>
                  );
                const hasRange = d.min !== undefined && d.max !== undefined;
                return (
                  <div
                    key={key}
                    style={{ marginBottom: '10px', fontSize: '11px' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '3px',
                      }}
                    >
                      <span style={{ color: '#42d4f4', fontWeight: 'bold' }}>
                        {label}
                      </span>
                      <div style={{ textAlign: 'right' }}>
                        <span style={{ color: '#fff' }}>
                          <b>{d.current.toFixed(0)}°</b>
                        </span>
                        {(() => {
                          const base = baselineData?.rom?.[key];
                          if (base === null || base === undefined) return null;
                          const delta = d.current - base;
                          const col =
                            Math.abs(delta) < 1
                              ? '#888'
                              : delta > 0
                              ? '#00ff88'
                              : '#ff6644';
                          return (
                            <div style={{ fontSize: '9px', color: col }}>
                              {delta > 0 ? '+' : ''}
                              {delta.toFixed(0)}°
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                    {hasRange && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: '3px',
                          fontSize: '10px',
                        }}
                      >
                        <span style={{ color: '#ff9d00' }}>
                          Min: {d.min.toFixed(0)}°
                        </span>
                        <span style={{ color: '#00ff88' }}>
                          Max: {d.max.toFixed(0)}°
                        </span>
                        <span style={{ color: '#fff' }}>
                          Δ {(d.max - d.min).toFixed(0)}°
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        background: '#333',
                        height: '5px',
                        borderRadius: '3px',
                        position: 'relative',
                      }}
                    >
                      {hasRange && (
                        <div
                          style={{
                            position: 'absolute',
                            left: `${(d.min / ROM_MAX_ANGLE) * 100}%`,
                            width: `${Math.max(
                              2,
                              ((d.max - d.min) / ROM_MAX_ANGLE) * 100
                            )}%`,
                            height: '100%',
                            background: romActive ? '#00ff88' : '#42d4f4',
                            borderRadius: '3px',
                            opacity: 0.6,
                          }}
                        />
                      )}
                      <div
                        style={{
                          position: 'absolute',
                          left: `${(d.current / ROM_MAX_ANGLE) * 100}%`,
                          transform: 'translateX(-50%)',
                          width: '8px',
                          height: '8px',
                          background: '#fff',
                          borderRadius: '50%',
                          top: '-1.5px',
                          boxShadow: '0 0 3px rgba(0,0,0,0.5)',
                        }}
                      />
                    </div>
                  </div>
                );
              })}
              {}
              {(() => {
                const symPairs = [
                  { label: 'Łokcie', left: 'leftElbow', right: 'rightElbow' },
                  { label: 'Kolana', left: 'leftKnee', right: 'rightKnee' },
                ];
                const rows = symPairs
                  .map(({ label, left, right }) => {
                    const lD = romData[left];
                    const rD = romData[right];
                    if (lD?.current === undefined || rD?.current === undefined)
                      return null;
                    const lVal = lD.current;
                    const rVal = rD.current;
                    const diff = Math.abs(lVal - rVal);
                    const sym = Math.max(0, Math.round(100 - diff));
                    const symColor =
                      diff <= 5
                        ? '#00ff88'
                        : diff <= 15
                        ? '#ffff00'
                        : '#ff6644';
                    const lRange =
                      lD.min !== undefined && lD.max !== undefined
                        ? lD.max - lD.min
                        : null;
                    const rRange =
                      rD.min !== undefined && rD.max !== undefined
                        ? rD.max - rD.min
                        : null;
                    const rangeSym =
                      lRange !== null &&
                      rRange !== null &&
                      Math.max(lRange, rRange) > 0
                        ? Math.round(
                            (Math.min(lRange, rRange) /
                              Math.max(lRange, rRange)) *
                              100
                          )
                        : null;
                    const rangeSymColor =
                      rangeSym === null
                        ? null
                        : rangeSym >= 90
                        ? '#00ff88'
                        : rangeSym >= 75
                        ? '#ffff00'
                        : '#ff6644';
                    return {
                      label,
                      lVal,
                      rVal,
                      diff,
                      sym,
                      symColor,
                      lRange,
                      rRange,
                      rangeSym,
                      rangeSymColor,
                    };
                  })
                  .filter(Boolean);
                if (!rows.length) return null;
                return (
                  <div
                    style={{
                      borderTop: '1px solid #333',
                      marginTop: '6px',
                      paddingTop: '8px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '10px',
                        color: '#888',
                        marginBottom: '6px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                      }}
                    >
                      Symetria
                    </div>
                    {rows.map(
                      ({
                        label,
                        lVal,
                        rVal,
                        diff,
                        sym,
                        symColor,
                        lRange,
                        rRange,
                        rangeSym,
                        rangeSymColor,
                      }) => (
                        <div
                          key={label}
                          style={{ marginBottom: '8px', fontSize: '11px' }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginBottom: '3px',
                            }}
                          >
                            <span style={{ color: '#aaa' }}>{label}</span>
                            <span
                              style={{ color: symColor, fontWeight: 'bold' }}
                            >
                              {sym}%
                            </span>
                          </div>
                          <div
                            style={{
                              position: 'relative',
                              height: '6px',
                              background: '#2a2a2a',
                              borderRadius: '3px',
                              margin: '3px 0',
                            }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                right: '50%',
                                width: `${(lVal / ROM_MAX_ANGLE) * 50}%`,
                                height: '100%',
                                background: symColor,
                                opacity: 0.7,
                                borderRadius: '3px 0 0 3px',
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                left: '50%',
                                width: `${(rVal / ROM_MAX_ANGLE) * 50}%`,
                                height: '100%',
                                background: symColor,
                                opacity: 0.7,
                                borderRadius: '0 3px 3px 0',
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                left: '50%',
                                width: '1px',
                                height: '100%',
                                background: '#555',
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              fontSize: '10px',
                              color: '#aaa',
                            }}
                          >
                            <span>L {lVal.toFixed(0)}°</span>
                            <span style={{ color: '#555' }}>
                              Δ {diff.toFixed(0)}°
                            </span>
                            <span>P {rVal.toFixed(0)}°</span>
                          </div>
                          {rangeSym !== null && (
                            <div
                              style={{
                                fontSize: '9px',
                                color: '#666',
                                textAlign: 'center',
                                marginTop: '2px',
                              }}
                            >
                              Zakres:{' '}
                              <span style={{ color: rangeSymColor }}>
                                {rangeSym}%
                              </span>{' '}
                              (L:{lRange.toFixed(0)}° P:{rRange.toFixed(0)}°)
                            </div>
                          )}
                        </div>
                      )
                    )}
                  </div>
                );
              })()}
            </div>
          </DraggableWindow>,
          document.body
        )}
      {metrics &&
        isReady &&
        createPortal(
          <DraggableWindow
            title="Analiza Postawy"
            initialX={windowPositions.metrics.x}
            initialY={windowPositions.metrics.y}
            width={220}
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              border: '2px solid #42d4f4',
              borderRadius: '8px',
              color: '#fff',
              zIndex: 10001,
              boxShadow: '0 0 20px rgba(0,0,0,0.5)',
            }}
          >
            <div style={{ padding: '10px' }}>
              <div
                style={{
                  marginBottom: '8px',
                  paddingBottom: '8px',
                  borderBottom: '1px solid #333',
                }}
              >
                {baselineData ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    <span
                      style={{ flex: 1, fontSize: '10px', color: '#ff9d00' }}
                    >
                      Baza aktywna
                    </span>
                    <button
                      type="button"
                      onClick={clearBaseline}
                      style={{
                        padding: '3px 7px',
                        background: '#333',
                        border: '1px solid #555',
                        borderRadius: '3px',
                        color: '#aaa',
                        fontSize: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      Wyczyść
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={captureBaseline}
                    style={{
                      width: '100%',
                      padding: '4px 0',
                      background: '#1a3a2a',
                      border: '1px solid #00aa55',
                      borderRadius: '3px',
                      color: '#00ff88',
                      fontSize: '10px',
                      cursor: 'pointer',
                    }}
                  >
                    Ustaw punkt odniesienia
                  </button>
                )}
              </div>
              {Object.entries(metrics).map(([key, data]) => {
                const currentNum = parseFloat(data.value);
                const baselineNum = baselineData?.metrics?.[key];
                const delta =
                  !Number.isNaN(currentNum) &&
                  baselineNum !== null &&
                  baselineNum !== undefined
                    ? currentNum - baselineNum
                    : null;
                const deltaColor =
                  delta === null
                    ? null
                    : delta < -0.5
                    ? '#00ff88'
                    : delta > 0.5
                    ? '#ff6644'
                    : '#888';
                const hist = metricsHistoryRef.current[key];
                const sparkline = (() => {
                  if (!hist || hist.length < 3) return null;
                  const W = 200;
                  const H = 14;
                  const min = Math.min(...hist);
                  const max = Math.max(...hist);
                  const range = max - min;
                  const pts = hist
                    .map((v, i) => {
                      const x = (i / (hist.length - 1)) * W;
                      const y =
                        range < 0.1
                          ? H / 2
                          : H - ((v - min) / range) * (H - 2) - 1;
                      return `${x.toFixed(1)},${y.toFixed(1)}`;
                    })
                    .join(' ');
                  return (
                    <svg
                      width="100%"
                      height={H}
                      viewBox={`0 0 ${W} ${H}`}
                      preserveAspectRatio="none"
                      style={{ display: 'block', marginTop: '3px' }}
                    >
                      <polyline
                        points={pts}
                        fill="none"
                        stroke={data.color}
                        strokeWidth="1.5"
                        opacity="0.55"
                      />
                    </svg>
                  );
                })();
                return (
                  <div
                    key={key}
                    style={{ marginBottom: '8px', fontSize: '11px' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          width: '10px',
                          height: '10px',
                          backgroundColor: data.color,
                          marginRight: '10px',
                          borderRadius: '50%',
                          flexShrink: 0,
                        }}
                      />
                      <div style={{ flex: 1 }}>{data.label}</div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: 'bold', color: data.color }}>
                          {data.value}
                        </div>
                        {delta !== null && (
                          <div style={{ fontSize: '9px', color: deltaColor }}>
                            {delta > 0 ? '+' : ''}
                            {delta.toFixed(1)}
                          </div>
                        )}
                      </div>
                    </div>
                    {sparkline}
                  </div>
                );
              })}
              <button
                type="button"
                onClick={takeSnapshot}
                style={{
                  width: '100%',
                  marginTop: '8px',
                  padding: '5px 0',
                  background: '#1a2a3a',
                  border: '1px solid #42d4f4',
                  borderRadius: '3px',
                  color: '#42d4f4',
                  fontSize: '11px',
                  cursor: 'pointer',
                }}
              >
                📸 Zapisz snapshot
              </button>
            </div>
          </DraggableWindow>,
          document.body
        )}
    </>
  );
};
export default Ar;
